import React from "react";
import TitleContainer from "../../components/common/Layout/TitleContainer";
import NetworkSupport from "../../components/NodeRPC/NetworkSupport";

const NodeRPC = () => {
  return (
    <>
      <TitleContainer title="노드 RPC" description="흑우촌 노드 RPC를 통해 블록체인에 손쉽게 접근하세요" style={{ "bkg-grey-ultralight": true }} />
      <NetworkSupport />
    </>
  );
};

export default NodeRPC;
